import type { EvidenceProps } from './registry';

// Fallback renderer for any check whose evidence renderer hasn't been written yet.
// Production should aim for ~zero of these — every check gets a custom renderer.

export const DefaultEvidence = ({ evidence }: EvidenceProps) => (
  <div className='evidence'>
    <p className='evidence__lead'>Evidence:</p>
    <pre className='evidence__raw'>{JSON.stringify(evidence, null, 2)}</pre>
  </div>
);
